export default __webpack_public_path__ + "static/media/86_desktop.764cb7ee.jpg";